const entity = {
  name: {
    singular: 'Usuário',
    plural: 'Usuários'
  },
  collection: 'users',
  tableHeaders: [
    { text: 'Nome', value: 'name' },
    { text: 'Email', value: 'email' },
    { text: 'Celular', value: 'cellphone' },
    { text: 'Permissão', value: 'role' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    fileAvatar: '',
    name: '',
    email: '',
    cellphone: '',
    role: 'writer',
    status: 'denied'
  },
  schema: {
    fields: [
      {
        type: 'image',
        label: 'Avatar',
        model: 'fileAvatar',
        required: true,
        hideInput: true
      },
      {
        type: 'input',
        inputType: 'text',
        label: 'Nome',
        model: 'name',
        required: true
      },
      {
        type: 'input',
        inputType: 'email',
        label: 'Email',
        model: 'email',
        required: true
      },
      {
        type: 'input',
        inputType: 'text',
        label: 'Celular',
        model: 'cellphone',
        required: false
      },
      {
        type: 'radios',
        label: 'Permissão',
        model: 'role',
        values: [
          { name: 'Administrador', value: 'admin' },
          { name: 'Redator', value: 'writer' }
        ],
        required: true
      },
      {
        type: 'switch',
        label: 'Status',
        model: 'status',
        textOn: 'Aprovado',
        textOff: 'Inativo',
        valueOn: 'approved',
        valueOff: 'denied'
      }
    ]
  },
  formOptions: {
    validateAfterLoad: false,
    validateAfterChanged: false,
    validateAsync: false
  }
}

export default [
  {
    path: '/users',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudList.vue')
  }, {
    path: '/users/new',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudForm.vue')
  }, {
    path: '/users/:id',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'banners' */ '../../components/Crud/CrudForm.vue')
  }
]
